"use client";

import {FiMessageCircle} from "react-icons/fi";
import CWFButton from "@/components/ui/CWFButton";
import Link from "next/link";
import {useState} from "react";
import PrivateMessageModal from "@/components/site/PrivateMessageModal";
export default function MessageAction({conversationExists = false,id}){
    const [privateMessageOpen, setPrivateMessageOpen] = useState(false);
    if(conversationExists){
        return (
            <Link href={`/dashboard/messages/${conversationExists.id}`}>
                <CWFButton className={"flex gap-x-2 w-full"}>
                    <FiMessageCircle/>
                    Message
                </CWFButton>
            </Link>
        )
    }else{
        return (
            <>
                <CWFButton className={"flex gap-x-2 w-full"} onClick={() => setPrivateMessageOpen(true)}>
                    <FiMessageCircle/>
                    Message
                </CWFButton>
                <PrivateMessageModal setPrivateMessageOpen={setPrivateMessageOpen} privateMessageOpen={privateMessageOpen} id={id}/>
            </>
        )
    }
}